import { fulfillmentColumns } from '../../shipping/fulfillments/columns';
import { messages } from './messages';
import { uiColumnToExportColumnMap } from './ui-column-to-export-column-map';
import { ExportOptions } from '../../components/modals/export-records-modal/enums/export-options-enum';
import { emptyArray } from 'ui-components/default-props/empty';
import { ColumnOrderByParamService } from '../../services/column-orderby-param-service';

const DEFAULT_EXPORT_FORMAT = 'CSV';

class FulfillmentExportHelperClass {
  getExportColumnNameFromUiColumnName(uiColumnName) {
    return uiColumnToExportColumnMap[uiColumnName];
  }

  getExportColumnsForLineItems(intl) {
    return [
      {
        columnId: 'ItemName',
        name: intl.formatMessage(messages.recordExportLineItemName),
      },
      {
        columnId: 'ItemQuantity',
        name: intl.formatMessage(messages.recordExportLineItemQuantity),
      },
      {
        columnId: 'ItemSku',
        name: intl.formatMessage(messages.recordExportLineItemSku),
      },
    ];
  }

  getRequestColumnConfiguration(columnConfiguration, intl) {
    return columnConfiguration.map((column) => {
      const base = fulfillmentColumns.find((baseColumn) => baseColumn.id === column.id) || {};
      const messageDescriptor = base.getMessageDescriptor && base.getMessageDescriptor();
      let name = base.getName && base.getName();

      if (intl && messageDescriptor) {
        name = intl.formatMessage(messageDescriptor);
      }
      return {
        columnId: this.getExportColumnNameFromUiColumnName(column.id),
        name,
      };
    });
  }

  getExportRequestParameters(
    viewRecordsOrSelectedRecords,
    primaryRecordsOrLineItems,
    selectedFulfillmentIds,
    orderByColumn,
    orderByDirection,
    columnConfiguration,
    searchTerm,
    intl,
    filters = {},
  ) {
    const exportColumnsWithoutLineItems = this.getRequestColumnConfiguration(columnConfiguration, intl);
    const fulfillmentIdsToExport =
      viewRecordsOrSelectedRecords === ExportOptions.EXPORT_ALL_RECORDS_IN_VIEW ? emptyArray : selectedFulfillmentIds || emptyArray;
    const shouldExportLineItems = primaryRecordsOrLineItems === ExportOptions.EXPORT_PRIMARY_RECORDS_AND_LINE_ITEMS;
    const exportColumns = shouldExportLineItems
      ? [...exportColumnsWithoutLineItems, ...this.getExportColumnsForLineItems(intl)]
      : exportColumnsWithoutLineItems;
    const orderByParam = ColumnOrderByParamService.getFulfillmentGridOrderByApiParamOrDefault(
      { id: orderByColumn, sorted: orderByDirection },
      true,
    );

    const requestBody = {
      fileType: DEFAULT_EXPORT_FORMAT,
      exportColumns: exportColumns.filter((col) => col.columnId),
      includeLineItems: shouldExportLineItems,
      filter: filters,
      ...orderByParam,
    };

    if (searchTerm) {
      requestBody.searchTerm = searchTerm;
    }

    if (fulfillmentIdsToExport && fulfillmentIdsToExport.length) {
      requestBody.filter = {
        ...filters,
        collectionFilters: [
          ...(filters.collectionFilters || []),
          {
            column: 'FulfillmentId',
            values: fulfillmentIdsToExport,
          },
        ],
      };
    }
    const requestUrl = this.formRequestUrlForExports();
    return {
      requestUrl,
      requestBody,
    };
  }

  formRequestUrlForExports() {
    return '/fulfillment/defaultExport';
  }

  formRequestUrlForCustomExports() {
    return '/seller/customextracts/exportFulfillments';
  }

  getCustomExportRequestParameters(
    viewRecordsOrSelectedRecords,
    extractId,
    selectedFulfillmentIds,
    orderByColumn,
    orderByDirection,
    searchTerm,
    filters,
  ) {
    const exportSelectedRecords = viewRecordsOrSelectedRecords === ExportOptions.EXPORT_SELECTED_RECORDS;
    const shouldExportFulfillmentPlansIds = exportSelectedRecords && selectedFulfillmentIds && selectedFulfillmentIds.length;
    const fulfillmentIdFilter = shouldExportFulfillmentPlansIds && {
      column: 'FulfillmentId',
      values: selectedFulfillmentIds,
    };
    const orderByParam = ColumnOrderByParamService.getFulfillmentGridOrderByApiParamOrDefault(
      { id: orderByColumn, sorted: orderByDirection },
      true,
    );

    const requestBody = {
      extractId,
      filter: filters || {},
      ...orderByParam,
    };
    if (filters?.collectionFilters || fulfillmentIdFilter) {
      requestBody.filter.collectionFilters = [...(filters?.collectionFilters || []), ...(fulfillmentIdFilter ? [fulfillmentIdFilter] : [])];
    }
    if (searchTerm) {
      requestBody.searchTerm = searchTerm;
    }
    const requestUrl = this.formRequestUrlForCustomExports();
    return {
      requestUrl,
      requestBody,
    };
  }
}

export const FulfillmentExportHelper = new FulfillmentExportHelperClass();
